import React from 'react';
import ProgressNotesView from '../../containers/ProgressNotes/ProgressNotesView';

const ProgressNotesNurseView = () => {
    return (
        <ProgressNotesView isNurse = {true}/>
    );
};
export default ProgressNotesNurseView;
